import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  position: relative;
  left: 0px;
  bottom: 0;
  padding: 1.5rem 0 1.5rem 0rem;
  font-size: 12px;
  line-height: 16px;
  color: ${({ theme }) => theme.textColor.secondary};
  background-color: #2F2F2F;
  
  @media (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
    left: 0;
  }

  p {
    padding: 15px 0 5px;
    border-top: 1px solid #A0A0A0;
  }

  a {
    color: ${({ theme }) => theme.textColor.secondary};
    text-decoration-line: underline;
  }
`

const Footer = () => (
  <Wrapper>
    <p>Version 1.03</p>
    <a href="https://www.fastmap.ai/legal/terms" target="_blank" rel="noreferrer">Terms of Use</a> - <a href="https://www.fastmap.ai/legal/privacy" target="_blank" rel="noreferrer">Privacy Policy</a>
  </Wrapper>
)

export default Footer;
